import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "题目名称",
            span: 8,
            model: "name",
            clearable: true,
        },
    ]
    const tableColumns = [
        {
            label: "题目名称",
            prop: "name",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "录入时间",
            prop: "createTime",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "题目名称",
            span: 24,
            placeholder: '请输入题目名称',
            model: "name",
        },
    ]

    const formRules = {
        name: [{
            required: true,
            trigger: "blur",
            message: '请输入题目名称'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
